import { Injectable, IterableDiffers } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
  HttpClient
} from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from './loader.service';
import { MatDialog } from '@angular/material/dialog';
import { Globals } from './global';
import * as Forge from 'node-forge';
import { LoginService } from '../../services/login.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  //errorCount:number = 0;
  latitude!: string;
  longitude!: string;
  loaderCount: number = 0;
  secretKey: any;
  constructor(
    private loginService: LoginService,
    private router: Router,
    private toastrService: ToastrService,
    private loaderService: LoaderService,
    public dialog: MatDialog,
    public globals: Globals,
    private http: HttpClient
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const authToken = localStorage.getItem('authToken');
    const encryptionkey = localStorage.getItem('encryptionkey');
    // let encryptionkey: any;
    let deviceId = localStorage.getItem('deviceId');

    if (!deviceId) {
      if (this.globals.deviceId && this.globals.deviceId != '') {
        deviceId = this.globals.deviceId;
      }
      else {
        deviceId = this.generateId(8);
        localStorage.setItem('deviceId', deviceId);
        this.globals.deviceId = deviceId;
      }
    }

    if (request.url.split('/').find(url => url == 'api')) {
      this.latitude = this.globals.latitute;
      this.longitude = this.globals.longitute;
      let language = 'EN';
      if (localStorage.getItem('language')) {
        let userDetails = JSON.parse(atob(sessionStorage.getItem('userDetails')!));
        let languageMap = JSON.parse(localStorage.getItem('languageMap')!);
        if (userDetails && languageMap) {
          language = languageMap[userDetails.clientId] == 'en' ? 'EN' : 'AR';
        }
        else {
          language = JSON.parse(localStorage.getItem('language')!) == 'en' ? "EN" : "AR";
        }
      }

      request = request.clone({
        headers: request.headers.
          append('ChannelId', '02').
          append('BankId', '01').
          append('CountryCode', '01').
          append('IP', '192.168.20.58').
          append('Latitude', this.latitude).
          append('Longitude', this.longitude).
          append('Platform', 'W').
          append('AppVersion', '1.0.0').
          append('DeviceId', deviceId).
          append('Language', language).
          append('MobileModel', this.detectBrowserName()).append('Access-Control-Allow-Origin', '*')
        // append('OSVersion', this.detectBrowserVersion())
      })
      // if (request.url.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
      //   request = request.clone({
      //     headers: request.headers
      //       .append('IsRefreshToken', 'false')
      //   })
      // } else {
      request = request.clone({
        headers: request.headers
          .append('IsRefreshToken', 'true')
      })
      // }
      if (authToken) {
        request = request.clone({
          headers: request.headers.append('Authorization', 'Bearer ' + authToken)
        })
      }
      // if (!request.url.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
      this.loaderService.setloader(true);
      this.loaderCount += 1;
      // }
      if (encryptionkey) {
        // let randomKey = this.generateId(32);
        // let self = this;
        // return from(self.importKey(randomKey)).pipe(switchMap((key: any) => {
        //   this.secretKey = key;
        //   let iv = new Uint8Array(16);  //generate empty uint8 array
        //   return from(self.aesEncrypt(JSON.stringify(request.body), self.secretKey, iv)).pipe(switchMap(function (cipherText) {
        //     let encrypted = self.bytesToBase64(cipherText);
        //     request = request.clone({
        //       body: encrypted,
        //       headers: request.headers.append('Key', self.encryptPublicKey(randomKey, encryptionkey))
        //         .append('Content-Type', 'application/json;charset=utf-8')
        //     })
        //     return next.handle(request).pipe(
        //       map((resp) => {
        //         if (resp instanceof HttpResponse) {
        //           //this.loaderService.setloader(false);
        //           const keys = resp.headers.keys();
        //           if (resp.headers.get('authorization')) {
        //             localStorage.setItem('authToken', resp.headers.get('authorization') + '')
        //           }
        //           if (resp.body && resp.body.status && resp.body.status.isSuccess == true) {
        //             // if (!resp.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
        //             self.loaderService.setloader(false);
        //             self.loaderCount--;
        //             // }
        //           } else {
        //             // if (!resp.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
        //             self.loaderService.setloader(false);
        //             self.loaderCount--;
        //             // }
        //           }
        //         }
        //         return resp
        //       }),
        //       catchError((error: HttpErrorResponse) => {
        //         // if (!error.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
        //         self.loaderService.setloader(false);
        //         self.loaderCount--;
        //         // }
        //         // Server Error
        //         // Logout if token expired
        //         if (error && error.error && ((error.error.status && error.error.status.isSuccess == false) || (error.error.Status && error.error.Status.isSuccess == false))) {
        //           self.globals.errorCount = self.globals.errorCount + 1;
        //           if (error.status == 401 && self.globals.errorCount == 1) {
        //             self.toastrService.error((error.error.status?.statusMessage || error.error.Status.StatusMessage));
        //           } else if (error.status != 401) {
        //             self.toastrService.error((error.error.status?.statusMessage || error.error.Status.StatusMessage));
        //           }
        //           setTimeout(() => {
        //             self.globals.errorCount = 0;
        //           }, 3000);

        //           if (error.error.status && error.error.status.isSuccess == false) {
        //             localStorage.removeItem('encryptionKey');
        //             localStorage.removeItem('authToken');
        //             sessionStorage.removeItem('userDetails');
        //             if (self.dialog.openDialogs.length > 0) {
        //               self.dialog.closeAll();
        //             }
        //             self.router.navigate(['/login']);
        //           }
        //         }
        //         return throwError(error);
        //       })
        //     );;
        //   }));
        // }));
        let self = this;
        const randomKey = this.generateId(32);
        let iv = new Uint8Array(16);
        const forgeIv = this.convertUint8ArrayToForgeBytes(iv); // Convert to Forge bytes
        const encryptedKey = this.encryptPublicKey(randomKey, encryptionkey);
        return from(this.aesEncryptWithForge(JSON.stringify(request.body), randomKey, forgeIv)).pipe(
          switchMap((encryptedBody) => {
            request = request.clone({
              body: encryptedBody,
              headers: request.headers.append('Key', encryptedKey).append('Content-Type', 'application/json;charset=utf-8'),
            });
            // this.aesDecryptWithForge(encryptedBody, randomKey, forgeIv);


            return next.handle(request).pipe(
              map((resp) => {
                if (resp instanceof HttpResponse) {
                  const keys = resp.headers.keys();
                  if (resp.headers.get('authorization')) {
                    localStorage.setItem('authToken', resp.headers.get('authorization') + '')
                  }
                  if (resp.body && resp.body.status && resp.body.status.isSuccess == true) {
                    // if (!resp.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
                      self.loaderService.setloader(false);
                      self.loaderCount--;
                    // }
                  } else {
                    // if (!resp.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
                      self.loaderService.setloader(false);
                      self.loaderCount--;
                    // }
                  }
                }
                return resp;
              }),
              catchError((error: HttpErrorResponse) => {
                // if (!error.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
                  self.loaderService.setloader(false);
                  self.loaderCount--;
                // }
                // Server Error
                // Logout if token expired
                if (error && error.error && ((error.error.status && error.error.status.isSuccess == false) || (error.error.Status && error.error.Status.isSuccess == false))) {
                  self.globals.errorCount = self.globals.errorCount + 1;
                  if (error.status == 401 && self.globals.errorCount == 1) {
                    self.toastrService.error((error.error.status?.statusMessage || error.error.Status.StatusMessage));
                  } else if (error.status != 401) {
                    self.toastrService.error((error.error.status?.statusMessage || error.error.Status.StatusMessage));
                  }
                  setTimeout(() => {
                    self.globals.errorCount = 0;
                  }, 3000);

                  if (error.error.status && error.error.status.isSuccess == false) {
                    localStorage.removeItem('encryptionKey');
                    localStorage.removeItem('authToken');
                    sessionStorage.removeItem('userDetails');
                    if (self.dialog.openDialogs.length > 0) {
                      self.dialog.closeAll();
                    }
                    self.router.navigate(['/login']);
                  }
                }

                return throwError(error);
              })
            );
          })
        );

      }
      else {
        return next.handle(request).pipe(
          map((resp) => {
            if (resp instanceof HttpResponse) {
              //this.loaderService.setloader(false);
              const keys = resp.headers.keys();
              if (resp.headers.get('Authorization')) {
                localStorage.setItem('authToken', resp.headers.get('Authorization') + '')
              }
              if (resp.body && resp.body.status && resp.body.status.isSuccess == true) {
                // if (!resp.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
                this.loaderService.setloader(false);
                this.loaderCount--;
                // }
              } else {
                // if (!resp.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
                this.loaderService.setloader(false);
                this.loaderCount--;
                // }
              }
            }
            return resp
          }),
          catchError((error: HttpErrorResponse) => {
            // if (!error.url?.split('/').find(url => ['GetProductDetailsForDashboard'].includes(url))) {
            this.loaderService.setloader(false);
            this.loaderCount--;
            // }
            // Server Error
            // Logout if token expired
            if (error && error.error && ((error.error.status && error.error.status.isSuccess == false) || (error.error.Status && error.error.Status.isSuccess == false))) {
              this.globals.errorCount = this.globals.errorCount + 1;
              if (error.status == 401 && this.globals.errorCount == 1) {
                this.toastrService.error((error.error.status?.statusMessage || error.error.Status.StatusMessage),'Error');
              } else if (error.status != 401) {
                this.toastrService.error((error.error.status?.statusMessage || error.error.Status.StatusMessage),'Error');
              }
              setTimeout(() => {
                this.globals.errorCount = 0;
              }, 3000);

              if (error.error.status && error.error.status?.isSuccess == false) {
                localStorage.removeItem('encryptionKey');
                localStorage.removeItem('authToken');
                sessionStorage.removeItem('userDetails');
                // localStorage.clear();
                if (this.dialog.openDialogs.length > 0) {
                  this.dialog.closeAll();
                }
                this.router.navigate(['/login']);
              }
            }
            return throwError(error);
          })
        );;
      }
    }
    return next.handle(request);

  }

  // encrypt(text: any, key: any, iv: any): any {
  //   var encrypted = CryptoJS.AES.encrypt(text, key, {
  //     iv: iv,
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7
  //   });
  //   // return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encrypted.toString()));
  //   return encrypted.toString();
  // }

  encryptPublicKey(key: any, publicKey: any): string {
    // Rsa encryption using JSEncrypt
    // let $encrypt = new JSEncrypt();
    // $encrypt.setPublicKey(publicKey);
    // let encrypt = $encrypt.encrypt(key);
    // return encrypt.toString();

    // RSA-OAEP encryption
    publicKey = '-----BEGIN PUBLIC KEY-----' + publicKey + '-----END PUBLIC KEY-----'
    var publicKeyObject = Forge.pki.publicKeyFromPem(publicKey);
    var encrypted = publicKeyObject.encrypt(key, "RSA-OAEP");
    // Convert the encrypted data to base64 for easy transmission (if needed)
    return Forge.util.encode64(encrypted);
  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edg') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  detectBrowserVersion() {
    var userAgent = navigator.userAgent, tem,
      matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(matchTest[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (matchTest[1] === 'Chrome') {
      tem = userAgent.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
  }

  generateId(len: any) {
    var arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, this.dec2hex).join("");
  }

  dec2hex(dec: any) {
    return dec.toString(16).padStart(2, "0");
  }


  bytesToBase64(bytes: any) {
    if (!bytes)
      return null;
    bytes = new Uint8Array(bytes);
    const ctArray = Array.from(bytes)
    const ctStr = ctArray.map((byte: any) => String.fromCharCode(byte)).join('')
    const ctBase64 = btoa(ctStr)
    return ctBase64
  }

  base64ToUint8Array(hexString: any) {
    const ctStr: any = atob(hexString)
    const ctUint8 = new Uint8Array(ctStr.match(/[\s\S]/g).map((ch: string) => ch.charCodeAt(0)))
    return ctUint8
  }

  importKey(key: any) {
    key = new TextEncoder().encode(key);
    return crypto.subtle.importKey('raw', key, {
      "name": "AES-GCM"
    }, true, ['encrypt', 'decrypt']);
  }

  aesEncrypt(string: any, key: any, iv: any) {
    return crypto.subtle.encrypt({
      name: "aes-gcm",
      iv: iv,
      tagLength: 128 //can be 32, 64, 96, 104, 112, 120 or 128 (default)
    }, key, new TextEncoder().encode(string))
  }


  aesDecrypt(string: any, key: any, iv: any) {
    let self = this;
    return crypto.subtle.decrypt({
      name: "aes-gcm",
      iv: iv,
      tagLength: 128 //can be 32, 64, 96, 104, 112, 120 or 128 (default)
    }, key, self.base64ToUint8Array(string))
  }

  async aesDecryptWithForge(encryptedData: string, key: string, iv: string): Promise<string> {
    const rawData = Forge.util.decode64(encryptedData);
    const dataLength = rawData.length - 16; // Subtract tag length (16 bytes)
    const encryptedBytes = rawData.substring(0, dataLength);
    const tagBytes = rawData.substring(dataLength);

    const decipher = Forge.cipher.createDecipher('AES-GCM', key);
    decipher.start({
      iv: iv,
      tag: Forge.util.createBuffer(tagBytes),
    });
    decipher.update(Forge.util.createBuffer(encryptedBytes));
    // decipher.update(Forge.util.createBuffer(rawData));

    const success = decipher.finish();

    if (!success) {
      throw new Error('Decryption failed');
    }
    console.log(decipher.output.toString());
    return decipher.output.toString();
  }

  async aesEncryptWithForge(data: string, key: string, iv: string): Promise<string> {
    const cipher = Forge.cipher.createCipher('AES-GCM', key);
    cipher.start({ iv: iv });
    cipher.update(Forge.util.createBuffer(data, 'utf8'));
    cipher.finish();

    const encryptedData = cipher.output.getBytes();
    const tag = cipher.mode.tag.getBytes();

    // Combine encrypted data and tag for transmission
    return Forge.util.encode64(encryptedData + tag);

  }

  convertUint8ArrayToForgeBytes(uint8Array: Uint8Array): string {
    return Array.from(uint8Array)
      .map((byte) => String.fromCharCode(byte))
      .join('');
  }

}
